// src/routes/ContactPage.jsx
import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faMapMarkerAlt, faEnvelope, faPhoneAlt, faUser, faCommentAlt } from '@fortawesome/free-solid-svg-icons';
import { FaLinkedin, FaTwitter, FaInstagram } from 'react-icons/fa';
import Turnstile from 'react-turnstile';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './ContactPage.css';

const ContactPage = () => {
    const appName = "MyFit Menu AI";
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
    });
    const [captchaToken, setCaptchaToken] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState({ type: '', text: '' });

    const workerUrl = 'https://myfitmenu-ai.com/api/contact';

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitMessage({ type: '', text: '' });

        try {
            const response = await fetch(workerUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ ...formData, "cf-turnstile-response": captchaToken }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || result.details || `Server responded with ${response.status}`);
            }

            setSubmitMessage({
                type: 'success',
                text: result.message || 'Your message has been sent successfully! We will get back to you soon.'
            });
            setFormData({ name: '', email: '', subject: '', message: '' });
            setCaptchaToken('');
        } catch (error) {
            setSubmitMessage({
                type: 'danger',
                text: error.message || 'There was an error sending your message. Please try again.'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    console.log("Turnstile Site Key en el componente:", process.env.REACT_APP_TURNSTILE_SITE_KEY);
    return (
        <div className="min-vh-100 d-flex flex-column contact-page-wrapper">
            <Header />
            <main className="flex-grow-1 py-5">
                <Container>
                    <Row className="text-center mb-5">
                        <Col>
                            <FontAwesomeIcon icon={faPaperPlane} size="3x" className="text-primary mb-3" />
                            <h1 className="display-4 fw-bolder">Get In Touch</h1>
                            <p className="lead text-muted fs-5">
                                We're here to help and answer any question you might have. We look forward to hearing from you! 👋
                            </p>
                        </Col>
                    </Row>

                    <Row className="g-5 align-items-stretch">
                        <Col lg={7} className="mb-4 mb-lg-0 d-flex">
                            <Card className="contact-form-card shadow-lg border-0 w-100">
                                <Card.Body className="p-4 p-md-5">
                                    <h3 className="fw-bold mb-4 text-primary">Send Us a Message</h3>
                                    {submitMessage.text && (
                                        <Alert
                                            variant={submitMessage.type}
                                            onClose={() => setSubmitMessage({ type: '', text: '' })}
                                            dismissible
                                            className="mt-3"
                                        >
                                            {submitMessage.text}
                                        </Alert>
                                    )}
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group className="mb-3 floating-label-group">
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                placeholder=" "
                                                required
                                                id="contactName"
                                                disabled={isSubmitting}
                                            />
                                            <Form.Label htmlFor="contactName"><FontAwesomeIcon icon={faUser} className="me-2" />Your Name</Form.Label>
                                        </Form.Group>

                                        <Form.Group className="mb-3 floating-label-group">
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                placeholder=" "
                                                required
                                                id="contactEmail"
                                                disabled={isSubmitting}
                                            />
                                            <Form.Label htmlFor="contactEmail"><FontAwesomeIcon icon={faEnvelope} className="me-2" />Your Email</Form.Label>
                                        </Form.Group>

                                        <Form.Group className="mb-3 floating-label-group">
                                            <Form.Control
                                                type="text"
                                                name="subject"
                                                value={formData.subject}
                                                onChange={handleChange}
                                                placeholder=" "
                                                required
                                                id="contactSubject"
                                                disabled={isSubmitting}
                                            />
                                            <Form.Label htmlFor="contactSubject"><FontAwesomeIcon icon={faCommentAlt} className="me-2" />Subject</Form.Label>
                                        </Form.Group>

                                        <Form.Group className="mb-4 floating-label-group">
                                            <Form.Control
                                                as="textarea"
                                                rows={5}
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                placeholder=" "
                                                required
                                                id="contactMessage"
                                                style={{ resize: 'none' }}
                                                disabled={isSubmitting}
                                            />
                                            <Form.Label htmlFor="contactMessage">Your Message</Form.Label>
                                        </Form.Group>

                                        {/* 🔐 Turnstile Widget */}

                                        <div className="mb-4">
                                            <Turnstile
                                                sitekey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                                                onVerify={(token) => {
                                                    console.log("Turnstile VERIFIED, token:", token);
                                                    setCaptchaToken(token);
                                                }}
                                                onError={(errorCode) => { // errorCode es opcional
                                                    console.error("Turnstile ERROR:", errorCode);
                                                    setSubmitMessage({ type: 'danger', text: 'Security challenge failed. Please try again.' });
                                                    setCaptchaToken('');
                                                }}
                                                onExpire={() => {
                                                    console.warn("Turnstile EXPIRED");
                                                    setSubmitMessage({ type: 'warning', text: 'Security challenge expired. Please try again.' });
                                                    setCaptchaToken('');
                                                }}
                                            />

                                        </div>

                                        <div className="d-grid">
                                            <Button
                                                variant="primary"
                                                type="submit"
                                                size="lg"
                                                disabled={isSubmitting || !captchaToken}
                                                className="fw-bold py-3"
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                                        Sending...
                                                    </>
                                                ) : (
                                                    <>
                                                        <FontAwesomeIcon icon={faPaperPlane} className="me-2" /> Send Message
                                                    </>
                                                )}
                                            </Button>
                                        </div>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col lg={5} className="d-flex">
                            <Card className="contact-info-card bg-primary text-white shadow-lg border-0 w-100">
                                <Card.Body className="p-4 p-md-5 d-flex flex-column">
                                    <h3 className="fw-bold mb-4">Contact Information</h3>
                                    <p className="mb-4">
                                        Feel free to reach out through any of these channels. We're eager to connect!
                                    </p>
                                    <div className="contact-detail mb-3">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} size="lg" className="me-3" />
                                        <span>123 Wellness Ave, HealthCity, HC 54321</span>
                                    </div>
                                    <div className="contact-detail mb-3">
                                        <FontAwesomeIcon icon={faPhoneAlt} size="lg" className="me-3" />
                                        <a href="tel:+1234567890" className="text-white text-decoration-none">+1 (234) 567-890</a>
                                    </div>
                                    <div className="contact-detail mb-4">
                                        <FontAwesomeIcon icon={faEnvelope} size="lg" className="me-3" />
                                        <a href={`mailto:support@${appName.toLowerCase().replace(/\s+/g, '')}.com`} className="text-white text-decoration-none">support@{appName.toLowerCase().replace(/\s+/g, '')}.com</a>
                                    </div>
                                    <div className="mt-auto">
                                        <h5 className="fw-semibold mb-3">Follow Us</h5>
                                        <div className="social-icons-contact">
                                            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon me-3" aria-label="LinkedIn">
                                                <FaLinkedin size={32} />
                                            </a>
                                            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon me-3" aria-label="Twitter">
                                                <FaTwitter size={32} />
                                            </a>
                                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                                                <FaInstagram size={32} />
                                            </a>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </main>
            <Footer />
        </div>
    );
};

export default ContactPage;
